<template>
  <Report
    :url="Url"
    :title="Title"
    :gridLayout="gridLayout"
    :listLayout="listLayout"
    :enableDate="enableDate"
  />
</template>

<script>
import Report from "@/components/reportLayout.vue";

export default {
  props: ["url", "name", "layout", "grid", "list", "enableDate"],
  components: {
    Report,
  },
  data() {
    return {
      Url: this.url,
      Title: this.name,
      gridLayout: this.layout.gridLayout[this.grid],
      listLayout: this.layout.listLayout[this.list],
    };
  },
};
</script>
